module.exports = __webpack_public_path__ + "img/linkedin-icon.d5bd0977.svg";